// apps/web/src/features/commercial-proposals/sheet/SheetCostColumn.tsx
//
// @aiPurpose render ONE cost column (buyout or logistics) of the customer
//   sheet (#1217): a titled head with the term chip, then the ordered rows.
//   Rows are rendered by ITERATING the DTO array — a `tone: 'total'` row is
//   emphasised, a `tone: 'pay'` row becomes the coloured rouble pay band, and
//   every other row is a plain dotted line. The China-delivery row is simply
//   absent from the array when zero; this component never indexes by position.
import type { CommercialProposalPublicLine } from '@magimp/shared';

export function SheetCostColumn({
  variant,
  title,
  term,
  lines,
}: {
  variant: 'buy' | 'log';
  title: string;
  term: string;
  lines: CommercialProposalPublicLine[];
}) {
  const plainLines = lines.filter((l) => l.tone !== 'pay');
  const payLine = lines.find((l) => l.tone === 'pay') ?? null;
  return (
    <section className={`kp-col ${variant === 'buy' ? 'kp-col-buy' : 'kp-col-log'}`}>
      <div className="kp-col-head">
        <h3 className="kp-col-title">{title}</h3>
        {term ? <span className="kp-col-term">{term}</span> : null}
      </div>
      {plainLines.map((line, i) => (
        <div
          key={`${i}-${line.label}`}
          className={`kp-line${line.tone === 'total' ? ' kp-line-total' : ''}`}
        >
          <span className="kp-line-label">{line.label}</span>
          <span className="kp-line-value">{line.value}</span>
        </div>
      ))}
      {payLine ? (
        <div className="kp-payrow">
          <span className="kp-payrow-label">{payLine.label}</span>
          <span className="kp-payrow-value">{payLine.value}</span>
        </div>
      ) : null}
    </section>
  );
}
